import React, { useState } from "react";

const HomePage = ({ students }) => {
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState({
    id: "",
    name: "",
    grade: "",
    warning: false,
  });
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setValue({ [name]: value });   
  }; 

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setDetails({ warning: true });
      if (value === "") {
        setDetails({ warning: true });
      }
      students.forEach((st) => {                        
        if (st.id === value.id)                              
          setDetails({
            id: value,
            name: st.name,
            grade: st.grade,
            warning: false,
          });
      });
    }, 500);
  };

  return (
    <div className="container mt-4">
      <h1> Проверка на резултати от ДИ по специалността </h1>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="formGroupExampleInput"> Входящ №: </label>
          <input
            autoComplete="off"
            onChange={handleChange}
            type="text"
            name="id"
            className="form-control"
            placeholder="ВХОДЯЩ номер от служебната бележка"
          />
        </div>
        {loading ? (
          <button type="submit" className="btn btn-primary" disabled>
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
        ) : (
          <button type="submit" className="btn btn-success">
            Провери
          </button>
        )}
      </form>
      {details.name && (
        <div className="jumbotron mt-4">
          <h1 className="display-4">{details.name}</h1>
          <hr className="my-4" />
          <p>
            Оценка от Държавен изпит за придобиване на професионална
            квалификация - дипломен проект:
            <b style={{ fontSize: "1.5rem" }}> {details.grade}</b>
          </p>
        </div>
      )}
      {details.warning && (
        <div className="alert alert-danger mt-4" role="alert">
          Грешен входящ №
        </div>
      )}
    </div>
  );
};

export default HomePage;
